import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route
} from 'react-router-dom';
import Tools from './app/tool/Tools';
import Home from './app/home/Home';
import Header from './app/always/Header';
import Footer from './app/always/Footer';
import FourOFour from './app/error/FourOFour';
import Metadata from './app/always/Metadata';

function Router() {
  return (
    <BrowserRouter>
      <Metadata />
      <Header />
      <div style={{ height: 'calc(100% - 120px)', overflow: 'auto' }}>
        <Switch>
          <Route path='/tools/:toolName?' component={Tools} />
          <Route exact path={['/', '/home']} component={Home} />
          <Route path='*' component={FourOFour} />
        </Switch>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default Router;